import React from 'react'

import { LineAndPoints as Component } from './component'
//
const LineAndPoints = props => {
  return <Component {...props} />
}
export default LineAndPoints
